import React from 'react';

export const AppFooter: React.FC<{  }> = props => {
  return (
    <div style={{ textAlign: 'center' }}>
      Dashboard Safouene1 ©2023
    </div>
  );
};